<template>
  <div class="userComp">
    <tbl-one-comp :rows="user"/>
  </div>
</template>

<script>
export default {
  name: 'userComp',
  props: {
    params: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      moduleName: 'users',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { params: this.params, required: this.required })
  },
  components: {
  },
  computed: {
    user: function () { return this.$store.getters[`${this.moduleName}/getOne`] }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
